import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {Button, Currency, Flex, Text} from 'components/UIKit';
import * as locales from '../../locales';
import * as styles from './CardCta.scss';

interface CardCtaProps {
  shop: Shop;
  shopPath: string;
  layout: string;
}

export function CardCtaComponent({shop, shopPath, layout, i18n}: CardCtaProps & WithI18nProps) {
  const CardButton = () => (
    <Button
      url={shopPath}
      label={i18n.translate('viewListing')}
      className={classNames(styles.cta, styles[layout])}
      aria-label={`${i18n.translate('viewListing')} ${shop.title}`}
    />
  );

  return layout === 'grid' ? (
    <CardButton />
  ) : (
    <div className={classNames(styles.ctaWrapper, styles[layout])}>
      <Flex className={styles.askingPrice} justifyContent="space-between">
        <Text
          type="small"
          text={i18n.translate('askingPrice')}
          className={classNames(styles.askingPriceLabel, styles[layout])}
        />
        <Currency className={styles.currency} display="bold" emphasis value={shop.salePrice} />
      </Flex>
      <CardButton />
    </div>
  );
}

export const CardCta = withI18n({
  id: 'CardCta',
  fallback: locales.en,
})(CardCtaComponent);
